import { browserEnv, IWeixinShareOptions } from "@/libs/lib";
import axios from "axios";

export const WxSdk = {
  p: null as Promise<any>,
  loadSdk() {
    if (!browserEnv.isWeixin) return Promise.reject();

    WxSdk.p = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";
      script.onload = resolve;
      script.onerror = reject;
      document.body.append(script);
    });

    return WxSdk.p;
  },
  config(debug = false) {
    return this.loadSdk()
      .then(() => {
        let type = "3";
        let hostName = window.location.hostname;

        if (hostName === "w6.soulsmile.cn" || hostName === "w3.soulapp.cn" || hostName === "w7.soulsmile.cn" || hostName === "w13.soulsmile.cn") {
          type = "1";
        } else if (hostName === "w3.soulsmile.cn" || hostName === "w4.soulsmile.cn" || hostName === "w5.soulsmile.cn") {
          type = "2";
        }

        return new Promise((resolve, reject) => {
          axios
            .get<{
              data: {
                appid: string;
                noncestr: string;
                timestamp: string;
                signature: string;
              };
            }>("https://api-h5.soulapp.cn/html/h5/signature", { params: { type, url: window.location.href.split("#")[0] } })
            .then((res) => {
              window.wx.error(reject);
              window.wx.ready(resolve);

              window.wx.config({
                debug,
                appId: res.data.data.appid,
                nonceStr: res.data.data.noncestr,
                timestamp: res.data.data.timestamp,
                signature: res.data.data.signature,
                jsApiList: ["updateTimelineShareData", "updateAppMessageShareData", "chooseWXPay", "hideMenuItems"],
                openTagList: ["wx-open-launch-app"],
              });
            });
        });
      })
      .catch((err) => {
        console.info("wxsdk 初始化失败", err);
      });
  },
  share(options: IWeixinShareOptions) {
    return new Promise<boolean>((resolve) => {
      const currentUrl = new URL(location.href);
      this.config(currentUrl.searchParams.has("eruda"))
        .then(() => {
          window.wx.ready(() => {
            window.wx.updateTimelineShareData({
              ...options,
              fail: () => resolve(false),
              cancel: () => resolve(false),
              success: () => resolve(true),
            });

            window.wx.updateAppMessageShareData({
              ...options,
              fail: () => resolve(false),
              cancel: () => resolve(false),
              success: () => resolve(true),
            });
          });
        })
        .catch((error) => {
          console.error("微信JSSDK认证失败", error);
          // alert("微信JSSDK认证失败")
        });
    });
  },
};
